<template>
  <div>
    <list-template
      :search-config="searchConfig"
      :table-config="tableConfig"
      :table-data="tableData"
      :total="total"
      :loading="loading"
      :current-page="page"
      @onChangePage="handleCurrentChange"
      @onSearch="onSearch"
      @onHandle="handleClick"
      @onChange="onChange"
      @onBatchImport ="handUpload"
      @onExportData ="handDownload"
    ></list-template>
    <Dialog :visible.sync="showImportDialog" title="导入数据表" size="small" buttonAlign="center" submitText="关闭" :showCancelButton="false" :showFooter="true" :closeOnClickModal="false">
      <LineWrapper labelWidth="100rem" labelColor="#222">
        <LineItem label="下载示例">
          <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownFile(0)">点此下载</el-button>
        </LineItem>
        <LineItem label="下载模板">
          <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownFile(1)">点此下载</el-button>
        </LineItem>
        <LineItem label="上传文件">
          <el-button size="small" icon="el-icon-upload2" @click="handleSelectFile">上传</el-button>
        </LineItem>
      </LineWrapper>
    </Dialog>
    <Dialog :visible.sync="showDialog" :title="title" buttonAlign="center" :submitText="submitText" :loading="dialogLoading" :showCancelButton="showCancelButton" :showFooter="true" :closeOnClickModal="false" :beforeClose="onBeforeClose">
      <LineWrapper class="list-box" label-width="130rem" list column="2">
        <LineItem :label="item.label" :value="item.value" v-for="item in list" :key="item.label"  :cssStyle="item.cssStyle" :color="item.color"></LineItem>
      </LineWrapper>
      <el-form ref="form" :model="formData" :rules="rules" label-width="140rem" label-position="left" v-if="showCancelButton">
        <el-form-item label="修改后金额" prop="money_answer_edit">
          <el-input v-model="formData.money_answer_edit" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import { tableListMixin } from '@/utils/mixins'
import Dialog from '@/components/common/Dialog'
import LineItem from '@/components/common/LineItem';
import LineWrapper from '@/components/common/LineWrapper';
import http, { zsGet, zsPost, fileDownload, get_school2 } from '@/api'
import { handleChooseFile, changeOption } from '@/utils'
import { validateNumber } from '@/utils/validate'
export default {
  _config:{'route':{'path':'list','meta':{'title':'列表','keepAlive':true}}},
  mixins: [tableListMixin],
  components: { Dialog, LineItem, LineWrapper },
  data() {
    return {
      showImportDialog: false,
      showDialog: false,
      dialogLoading: false,
      title: '',
      submitText: '',
      showCancelButton: false,
      searchConfig: [
        { prop: 'pay_status', tag: 'select', placeholder: '筛选订单状态', options: [] },
        { prop: 'school_id', tag: 'select', placeholder: '筛选就读学校', options: [] },
        { prop: 'entry_school_id', tag: 'select', placeholder: '筛选入账学校', options: [] },
        { prop: 'diff_fee', tag: 'select', placeholder: '筛选是否有差额分', options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ] },
        { prop: 'school_year', tag:"year", placeholder: '筛选缴费学年' },
        { prop: 'student_name', placeholder: '搜索学生姓名' }
      ],
      tableConfig: [
        {prop: 'pay_status_name', label: '订单状态'},
        {prop: 'student_name', label: '学生姓名'},
        {prop: 'student_no', label: '学号'},
        {prop: 'school_year', label: '缴费学年'},
        {prop: 'grade_name', label: '就读年级'},
        {prop: 'class_name', label: '行政班'},
        {prop: 'teacher_name', label: '班主任'},
        {prop: 'school', label: '就读校区'},
        {prop: 'entry_school', label: '入账学校'},
        {prop: 'money_answer', label: '应收金额'},
        {prop: 'diff_fee', label: '是否有差额分'},
        {prop: 'handle', label: '操作', width: 170, handle: true}
      ],
      list: [],
      formData: { money_answer_edit: '', id: '' },
      rules: {
        money_answer_edit: [
          { required: true, validator: (_, value, callback) => validateNumber(value, callback, { min: 0, max: 1000000, equalToMin: false, equalToMax: true }), trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      get_school2().then(res => {
        this.searchConfig[1].options = changeOption({list: res, label: 'school_name', value: 'id'})
        this.searchConfig[2].options = changeOption({list: res, label: 'school_name', value: 'id'})
      })
      zsGet('/recruit-2024/renew/screen').then(res => {
        const { pay_status_arr = [] } = res
        this.searchConfig[0].options = changeOption({list: pay_status_arr, label: 'pay_status_name', value: 'id'})
      })
    },
    getData() {
      this.getDataApi('/zhaosheng/api/recruit-2024/renew/list')
    },
    getDetail() {
      this.dialogLoading = true
      zsGet('/recruit-2024/renew/detail', { id: this.formData.id }).then(res => {
        this.formData.money_answer_edit = res.money_answer
        const arr = ['#F53F3F', '#23C343']
        const color = arr[res.pay_status] || '#9A9A9A'
        this.list = [
          { label: '订单状态', value: res.pay_status_name , cssStyle: {'grid-column': '1 / -1' }, color },
          { label: '学生姓名', value: res.student_name },
          { label: '学生身份证/护照号', value: res.student_idcard },
          { label: '缴费学年', value: res.school_year },
          { label: '入账学校', value: res.entry_school },
          { label: '修改前金额', value: res.money_answer_front },
          { label: '修改后金额', value: res.money_answer }
        ]
      }).finally(() => this.dialogLoading = false)
    },
    handleClick(row, handle) {
      this.formData.id = row.id
      const { type } = handle
      const { pay_status } = row
      // 0：待支付 1：已支付 7：已取消
      if (type === 'delete') {
          const maps = {
          0: { message: '订单删除后需重新导入，请谨慎操作！', confirmButtonText: '确认删除', cancelButtonText: '取消', showCancelButton: true, center: false },
          1: { message: '该订单已支付无法删除！', confirmButtonText: '我知道了', cancelButtonText: '取消', showCancelButton: false, center: true },
          7: { message: '该订单已取消无法删除！', confirmButtonText: '我知道了', cancelButtonText: '取消', showCancelButton: false, center: true }
        }
        const obj = maps[pay_status]
        if (!obj) return
        const { message, confirmButtonText, cancelButtonText, showCancelButton, center } = obj
        const loadingButtonText = '删除中'
        this.$confirm(message, '提示', {
          confirmButtonText,
          cancelButtonText,
          showCancelButton,
          center,
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              if (pay_status !== 0) return done()
              instance.confirmButtonLoading = true
              instance.confirmButtonText = loadingButtonText
              http({ url: '/recruit-2024/renew/delete', pre: 'zs', method: 'post' }, { id: row.id }).then((res) => {
                done()
                this.getData()
                this.$message({ type: 'success', message: '删除成功!' })
                // this.$message({ type: 'warning', message: '该订单状态已变更，请刷新后重试！' })
              }).finally(() => {
                instance.confirmButtonText = confirmButtonText
                instance.confirmButtonLoading = false
              })
            } else {
              done()
            }
          }
        })
        return
      } else if (type === 'edit') {
        this.title = '编辑'
        this.submitText = '提交'
        this.showCancelButton = true
        this.rules.money_answer_edit[0].required = true
        const arr = ['#F53F3F', '#23C343']
        const color = arr[row.pay_status] || '#9A9A9A'
        this.list = [
          { label: '订单状态', value: row.pay_status_name , cssStyle: {'grid-column': '1 / -1' }, color },
          { label: '学生姓名', value: row.student_name },
          { label: '学生身份证/护照号', value: row.student_idcard },
          { label: '缴费学年', value: row.school_year },
          { label: '入账学校', value: row.entry_school },
          { label: '修改前金额', value: row.money_answer_front }
        ]
      } else if (type === 'view') {
        this.title = '查看'
        this.submitText = '关闭'
        this.showCancelButton = false
        this.rules.money_answer_edit[0].required = false
        this.getDetail()
      }
      this.showDialog = true
    },
    initForm() {
      this.formData = { money_answer_edit: '', id: '' }
      this.list = []
    },
    onBeforeClose(done, instance) {
      const { type } = instance
      if(!this.showCancelButton || type !== 'submit') {
        done()
        this.initForm()
        return
      }
      this.$refs['form'].validate(valid => {
        if(valid) {
          instance.confirmButtonLoading = true
          zsPost('/recruit-2024/renew/edit', { ...this.formData }).then(() => {
            this.showDialog = false
            this.getData()
            done()
            this.initForm()
            this.$message.success({ message: '操作成功', duration: 3000 })
          }).finally(() => {
            instance.confirmButtonLoading = false
          })
        }
      })
    },
    handUpload() {
      this.showImportDialog = true
    },
    handleSelectFile() {
      handleChooseFile({
        api: '/zhaosheng/api/recruit-2024/renew/template',
        show: true,
        onSuccess: () => {
          this.showImportDialog = false
          this.$message.success({ message: '文件上传成功', duration: 5000 })
          this.getData()
        }
      })
    },
    handleDownFile(type) {
      const config = { name: `在校生续费${type ? '模板' : '示例'}`, type: 'xlsx' }
      const api = `${process.env.VUE_APP_URL_OSS}finance/${type ? 'template' : 'demo'}.xlsx`
      fileDownload(api, {}, config).then(res => {
        this.showImportDialog = false
      })
    },
    handDownload() {
      fileDownload('/zhaosheng/api/recruit-2024/renew/export', {...this.search}, { name: '在校生续费', show: true })
    },
  }
}
</script>

<style lang="scss" scoped>
// .list-box {
//   display: grid;
//   gap: 10rem 20rem;
//   grid-template-columns: repeat(auto-fill, minmax(200rem, 1fr));
// }
</style>
